import React from 'react';
import { reportCaughtError } from '../utilities/errorTracking';

export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    reportCaughtError(error, `render:${errorInfo?.componentStack?.split('\n')[1]?.trim() ?? 'unknown'}`);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="ff-page">
          <div className="ff-content" style={{ textAlign: 'center', paddingTop: 80 }}>
            <h1>Rain delay</h1>
            <p>Something went wrong loading this page.</p>
            <a className="ff-button ff-button-primary" href="/">Back to home plate</a>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}
